import { Link } from "react-router-dom";
import { money } from "@/lib/api";

export const priceInfo = (c) => {
  const discounted = c.compare_at_price && c.compare_at_price > c.price;
  return {
    discounted,
    pct: discounted ? Math.round((1 - c.price / c.compare_at_price) * 100) : 0,
    save: discounted ? c.compare_at_price - c.price : 0,
    label: money(c.price, c.currency).replace(".00", ""),
  };
};

export const PriceTag = ({ config, size = "lg", testid = "price-tag" }) => {
  const p = priceInfo(config);
  const big = size === "lg" ? "text-6xl" : "text-4xl";
  return (
    <div data-testid={testid}>
      {p.discounted && (
        <div className="flex items-center gap-3">
          <s className="text-lg text-[var(--plum-muted)]" aria-label={`Original price ${money(config.compare_at_price, config.currency)}`} data-testid={`${testid}-original`}>{money(config.compare_at_price, config.currency)}</s>
          <span className="rounded-full bg-[var(--rose)] px-3 py-1 text-xs font-bold tracking-wide text-white" data-testid={`${testid}-badge`}>{p.pct}% OFF</span>
        </div>
      )}
      <p className={`font-display mt-1 ${big} leading-none`} data-testid={`${testid}-price`}>{money(config.price, config.currency)}</p>
      {p.discounted && <p className="mt-2 text-sm font-semibold text-[var(--gold-deep)]" data-testid={`${testid}-save`}>You save {money(p.save, config.currency).replace(".00", "")}</p>}
    </div>
  );
};

export const PriceCTA = ({ config, testid, className = "" }) => (
  <Link to="/create" className={`btn-gold w-full ${className}`} data-testid={testid}>Create My Song — {priceInfo(config).label}</Link>
);
